if not App.angularApp?
    return

App.angularApp.directive 'mfMentionContainer', () ->
    return {
        restrict: 'EA'
        scope:
            text: '=model'
            is_open: '=toggle'
            pattern: '=pattern'
        controller: ['$scope', ($scope) ->

            @setPattern = (val, is_open) =>
                $scope.pattern = val
                $scope.is_open = is_open

            @setText = (val) =>
                $scope.text = val
                $scope.$apply()

            @get = (prop) =>
                return $scope[prop]

            return this
        ]
    }
